module.exports = __webpack_public_path__ + "static/media/Kuva_2_2.e61f9883.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_2_2.png
// module id = 1395
// module chunks = 0